import { IconPaths, ModalSize, OptionsHelper } from '../../../../../_metronic/helpers'
import {
  Button,
  CustomSelect,
  IOption,
  InfoAlert,
  TableCard,
  useModal,
} from '../../../../components'
import { EscalaFormModal } from '../components/EscalaFormModal'
import { EscalaEmpresaCalendario } from './components/EscalaEmpresaCalendario'
import {
  ParamsEscalaEmpresa,
  QueryRequestProvider,
  useQueryRequest,
} from './core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponse } from './core/QueryResponseProvider'
import { EscalaEmpresaTable } from './table/EscalaEmpresaTable'

const EscalaEmpresa = () => {
  const { state, updateState } = useQueryRequest<ParamsEscalaEmpresa>()
  const { refetch } = useQueryResponse()
  const { showModal } = useModal()

  const params = state.params ?? {}
  const empresa = params.empresa

  const abrirCadastro = () => {
    if (!empresa) return
    showModal({
      title: 'Nova escala da instituição',
      size: ModalSize.Large,
      content: <EscalaFormModal eixo='empresa' empresa={empresa} onSuccess={refetch} />,
    })
  }

  return (
    <>
      <TableCard className='mb-6'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <h3 className='card-label fw-bold text-gray-800'>Escala da instituição</h3>
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='row'>
            <div className='col-md-5'>
              {/* Toda rota do eixo empresa é escopada por `{empresa}` — o
                  isolamento multi-tenant é row-level por `empresa.id`. */}
              <label className='d-block'>
                <span className='fs-6 fw-bolder mb-2 d-block required'>Instituição</span>
                <CustomSelect
                  name='empresa'
                  placeholder='Selecione a instituição'
                  fetchOptions={OptionsHelper.getOptionsEmpresasAdmin}
                  isClearable
                  onChange={(opcao: IOption | null) =>
                    updateState({
                      params: {
                        ...params,
                        empresa: opcao ? Number(opcao.value) : undefined,
                      },
                      page: 0,
                    })
                  }
                />
              </label>
            </div>
          </div>
        </div>
      </TableCard>

      {!empresa ? (
        <InfoAlert variant='info' title='Escolha uma instituição'>
          Selecione a empresa acima para ver e administrar a escala dos profissionais dela.
        </InfoAlert>
      ) : (
        <>
          <TableCard className='mb-6'>
            <div className='card-header border-0 pt-6'>
              <div className='card-title'>
                <h3 className='card-label fw-bold text-gray-800'>Calendário</h3>
              </div>
            </div>
            <EscalaEmpresaCalendario empresa={empresa} />
          </TableCard>

          <TableCard>
            <div className='card-header border-0 pt-6'>
              <div className='card-title'>
                <h3 className='card-label fw-bold text-gray-800'>Escalas cadastradas</h3>
              </div>
              <div className='card-toolbar'>
                <Button className='btn btn-primary' icon={IconPaths.Add} onClick={abrirCadastro}>
                  Nova escala
                </Button>
              </div>
            </div>
            <EscalaEmpresaTable empresa={empresa} />
          </TableCard>
        </>
      )}
    </>
  )
}

export const EscalaEmpresaWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <EscalaEmpresa />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
